import { useEffect, useState } from "react";
import { getMeteoData } from "../api/meteo";

export const useGetMeteoHumidity = ({ meteoId, start, end }) => {
    const [observations, setObservations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHumidities = async () => {
      try {
        const result = await getMeteoData({
          meteoId,
          start,
          end,
          parameter: "humidity"
        });

        

        setObservations(result);
      } catch (error) {
        setError(error);
        console.error("Error al obtener humedades de la meteo:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchHumidities();
  }, [meteoId, start, end]);

  return { observations, loading, error };
};
